module.exports = __webpack_public_path__ + "img/wzy.0cc66257.png";